<div class="avatar">
  <common-mojo-avatar
    [id]="user.photoId"
    [initials]="getInitials(user)"
    [selectedPhotoShape]="avatarShape"
    [backgroundSize]="avatarBackgroundSize"
    data-cy="user-card-avatar"
  >
  </common-mojo-avatar>
</div>
<div
  class="user-data font-regular font-weight-normal"
  data-cy="user-card-name"
>
  <span
    class="name"
    *ngIf="markedCandidateName; else fullName"
  >
    <ng-content></ng-content>
  </span>
  <ng-template #fullName>
    {{ user.firstName }} {{ user.lastName }}
  </ng-template>
  <span class="role">
    {{ role }}
  </span>
</div>
